import { useEffect, useState } from 'react'
import { MAX_CHALLENGES } from '../../constants/settings'
import { CompletedRow } from './CompletedRow'
import { CurrentRow } from './CurrentRow'
import { EmptyRow } from './EmptyRow'
import { loadGameWonFromLocalStorage } from '../../lib/localStorage'
import hurdleOff from '../../hurdle-off-dark.svg';
import hurdleOn from '../../hurdle-on.svg';
import hurdleWinOff from '../../hurdle-win-off-dark.svg';
import hurdleWin from '../../hurdle-win.svg';

type Props = {
  guesses: string[]
  currentGuess: string
  isRevealing?: boolean
  currentRowClassName: string
  reset: boolean
  currentStep: number
  slideOutAnimation?: boolean
  slideInAnimation?: boolean
  lastStep: boolean
  isLastStepRevealing: boolean
  finalWon: boolean
  isHighContrast: boolean
  words: any
}

export const Grid = ({
  guesses,
  currentGuess,
  isRevealing,
  currentRowClassName,
  currentStep,
  slideOutAnimation,
  slideInAnimation,
  lastStep,
  isLastStepRevealing,
  finalWon,
  isHighContrast,
  words
}: Props) => {
  const empties =
    guesses.length < MAX_CHALLENGES - 1
      ? Array.from(Array(MAX_CHALLENGES - 1 - guesses.length))
      : []

    const [classes, setClasses] = useState("")

    useEffect(() => {
      if (slideOutAnimation) {
        setClasses(`slideOut`)
      }
      else if (slideInAnimation) {
        setClasses(`slideIn`)
      } else {
        setClasses("")
      }
      }, [slideOutAnimation, slideInAnimation])
      

    const [reveal, setReveal] = useState(false);
    const gameWon = loadGameWonFromLocalStorage();


    useEffect(() => {
      if (isRevealing) {
        setReveal(true)
      } else {
        setReveal(false)
      }
     }, [isRevealing])

  return (
    <div style={{ display: "inline-flex", flexDirection: "column"}}>
     <div className="hurdle-wrapper">     
         <div className="flex items-center justify-center hurdle">
           {currentStep > 1 ? <img  src={hurdleOn} alt="hurdle" />
           : <img  src={hurdleOff} alt="hurdleOff" /> }              
         </div>
        {/* <div className="line"></div> */}
 
         <div className="flex items-center justify-center hurdle">
           {currentStep > 2 ? <img  src={hurdleOn} alt="hurdle" />
           : <img  src={hurdleOff} alt="hurdleOff" /> }              
         </div>
         
     
       
         <div className="flex items-center justify-center hurdle">
           { currentStep > 3 ? <img  src={hurdleOn} alt="hurdle" />
           : <img  src={hurdleOff} alt="hurdleOff" /> }              
         </div> 
       
      
         <div className="flex items-center justify-center hurdle">
           { currentStep > 4 ? <img  src={hurdleOn} alt="hurdle" />
           : <img  src={hurdleOff} alt="hurdleOff" /> }              
         </div>
         
       
      
         <div className="flex items-center justify-center hurdle">
           {finalWon || gameWon  ? <img  src={hurdleWin} alt="hurdle" />
           : <img  src={hurdleWinOff} alt="hurdleOff" /> }              
          </div>
    </div>
    <div id="board" className={classes}>
      {guesses.map((guess, i) => (
        <CompletedRow
            currentStep={currentStep}
            key={i}
            guess={guess}
            isRevealing={(reveal && guesses.length - 1 === i) || isLastStepRevealing}
            lastStep={lastStep}
            isHighContrast={isHighContrast}
            words={words}
          />
      ))}
      {guesses.length < MAX_CHALLENGES && (
        <CurrentRow isHighContrast={isHighContrast} guess={currentGuess} className={currentRowClassName} />
      )}
      {empties.map((_, i) => (
        <EmptyRow key={i} />
      ))}
    </div>
    </div>
  )
}
